import { useQuery } from "@tanstack/react-query";
import { superAdminApi, type SearchParams } from "../../api/superadmin";

export const superAdminKeys = {
  all: ["superadmin"] as const,
  searchPlayers: (params: SearchParams) => ["superadmin", "players", "search", params] as const,
  searchUsers: (params: SearchParams) => ["superadmin", "users", "search", params] as const,
  searchTournaments: (params: SearchParams) => ["superadmin", "tournaments", "search", params] as const,
  searchMatches: (params: { playerId: number | null; page?: number; size?: number }) => ["superadmin", "matches", "search", params] as const,
};

export const useSearchPlayers = (params: SearchParams, enabled: boolean = true) =>
  useQuery({
    queryKey: superAdminKeys.searchPlayers(params),
    queryFn: () => superAdminApi.searchPlayers(params),
    enabled,
    placeholderData: (prev) => prev,
  });

export const useSearchUsers = (params: SearchParams, enabled: boolean = true) =>
  useQuery({
    queryKey: superAdminKeys.searchUsers(params),
    queryFn: () => superAdminApi.searchUsers(params),
    enabled,
    placeholderData: (prev) => prev,
  });

export const useSearchTournaments = (params: SearchParams, enabled: boolean = true) =>
  useQuery({
    queryKey: superAdminKeys.searchTournaments(params),
    queryFn: () => superAdminApi.searchTournaments(params),
    enabled,
    placeholderData: (prev) => prev,
  });

export const useSearchPlayerMatches = (playerId: number | null, page: number = 0, size: number = 25) =>
  useQuery({
    queryKey: superAdminKeys.searchMatches({ playerId, page, size }),
    queryFn: () => superAdminApi.searchMatches({ playerId: playerId!, page, size }),
    enabled: playerId != null,
    placeholderData: (prev) => prev,
  });
